module.exports = __webpack_public_path__ + "static/media/21ECLAC36.4a4646df.jpg";